<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Guest Surveys</div>
	</div>
	<p-divider></p-divider>
	<app-customer-survey-dashboard *ngIf="surveyResponsesLoaded"></app-customer-survey-dashboard>
	<p-tabView [activeIndex]="activatedTabPanelIndex">
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'bullhorn']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Survey Responses</div>
			</ng-template>
			<app-customer-survey-response-list
				*ngIf="surveyResponsesLoaded"
				[(surveyResponsesLoaded)]="surveyResponsesLoaded"
			></app-customer-survey-response-list>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'cog']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Survey Setup</div>
			</ng-template>
			<app-customer-survey-list *ngIf="surveyListLoaded"></app-customer-survey-list>
		</p-tabPanel>
	</p-tabView>
</div>
